<app-modal #modal>
  <div class="modal-header">
    <h2 class="modal-title">Clone Policy</h2>
    <button type="button" class="close" (click)="modal.hide()" aria-label="Close">
      <span aria-hidden="true"><i class="far fa-times"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" (submit)="onFormSubmit()">

      <table class="simple-form" aria-hidden="true">
        <tr>
          <th style="width: 140px;"><label>Country</label></th>
          <td>
            <div class="form-group">
              <app-autosuggest-dropdown-input #countrySelect [required]="true" [options]="countryOptions"
                                              placeholder="Select Country..." [parentForm]="form"
                                              controlName="country"></app-autosuggest-dropdown-input>
            </div>
          </td>
        </tr>
        <tr
          [ngStyle]="{'display': form.get('country').value !== '' && siteOptions.length > 0 ? 'table-row' : 'none'}">
          <th><label>Sites</label></th>
          <td>
            <mat-form-field appearance="fill" style="width: 100%;">
              <mat-label>All Sites</mat-label>
              <mat-select formControlName="sites" [formGroup]="form" multiple>
                <mat-option *ngFor="let site of siteOptions" [value]="site.value">{{site.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td colspan="2">&nbsp;</td>
        </tr>

        <tr>
          <th></th>
          <td colspan="2">
            <div class="btn-wrap">
              <div class="row">
                <div class="col-6">
                  <app-button
                    text="Cancel"
                    type="button"
                    (click)="modal.hide()"
                    [isBusy]="form.get('isBusy').value"
                    variant="secondary"
                    width="fill"
                  />
                </div>
                <div class="col-6">
                  <app-button
                    type="submit"
                    text="Clone Policy"
                    [isBusy]="form.get('isBusy').value"
                    width="fill"
                    [disabled]="form.invalid || form.get('isBusy').value || !hasBeenChanged()" />
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">&nbsp;</td>
        </tr>
      </table>

    </form>
  </div>
</app-modal>
